import Actions from '../actions/actions';
import PropTypes from 'prop-types';
import React from 'react';

const types = PropTypes;

export class Router extends React.Component {
  static propTypes = {
    router: types.oneOfType([types.object, types.func]),
  };

  componentDidMount() {
    const { router } = this.props;
    router.configure({ strict: false, html5history: true, resource: this, notfound: this.notFound });
    router.init();
  }

  render() {
    return null;
  }

  admin = () => Actions.setView({ page: 'admin' });

  collectCustomerInformation = (proposalId) => Actions.setView({ page: 'collectCustomerInformation', proposalId });

  collectAddressInformation = (proposalId) => Actions.setView({ page: 'collectAddressInformation', proposalId });

  reviewCustomerInformation = (proposalId) => Actions.setView({ page: 'reviewCustomerInformation', proposalId });

  handOff = (proposalId) => Actions.setView({ page: 'handOff', proposalId });

  stepDocumentsExternal = (proposalId) => Actions.setView({ page: 'stepDocumentsExternal', proposalId });

  stepDocuments = (proposalId) => Actions.setView({ page: 'stepDocuments', proposalId });

  customersList = () => Actions.setView({ page: 'customersList' });

  archivedCustomersList = () => Actions.setView({ page: 'archivedCustomersList' });

  documents = (proposalId) => Actions.setView({ page: 'documents', proposalId });

  failWhale = () => Actions.setView({ page: 'failWhale' });

  download = () => Actions.setView({ page: 'download' });

  productNotAvailable = () => Actions.setView({ page: 'productNotAvailable' });

  trainingRequired = () => Actions.setView({ page: 'trainingRequired' });

  noStateLicense = () => Actions.setView({ page: 'noStateLicense' });

  homeownerDocuments = (token) => Actions.setView({ page: 'homeownerDocuments', token });

  login = () => Actions.setView({ page: 'login' });

  resetPassword = () => Actions.setView({ page: 'resetPassword' });

  signUp = () => Actions.setView({ page: 'signUp' });

  newProposal = () => Actions.setView({ page: 'newProposal' });

  newProposalExplicit = () => Actions.setView({ page: 'newProposalExplicit' });

  paymentInformation = (proposalId) => Actions.setView({ page: 'paymentInformation', proposalId });

  proposalRedirect = (proposalId) => Actions.setView({ page: 'proposalRedirect', proposalId });

  confirmation = () => Actions.setView({ page: 'confirmation' });

  quickcheck = (proposalId) => Actions.setView({ page: 'quickcheck', proposalId });

  quickCheckStatus = (proposalId) => Actions.setView({ page: 'quickCheckStatus', proposalId });

  proposal = (proposalId, financingMethodId) => Actions.setView({ page: 'proposal', proposalId, financingMethodId });

  proposalSection = (proposalId, section) => Actions.setView({ page: 'proposal', proposalId, section });

  eligibilityStatus = (proposalId) => Actions.setView({ page: 'eligibilityStatus', proposalId });

  eligibilityPending = (proposalId) => Actions.setView({ page: 'eligibilityPending', proposalId });

  generatingDocuments = () => Actions.setView({ page: 'generatingDocuments' });

  savingsCalculator = (proposalId) => Actions.setView({ page: 'savingsCalculator', proposalId });

  stips = (proposalId) => Actions.setView({ page: 'stips', proposalId });

  status = () => Actions.setView({ page: 'status' });

  financingRequestDocsAdmin = () => Actions.setView({ page: 'financingRequestDocsAdmin' });

  financingRequestDocAdmin = () => Actions.setView({ page: 'financingRequestDocAdmin' });

  homeownerEligibility = (consentToken) => Actions.setView({ page: 'homeownerEligibility', consentToken });

  homeownerEligibilitySubmitted = () => Actions.setView({ page: 'homeownerEligibilitySubmitted' });

  frDocumentsTier1List = () => Actions.setView({ page: 'frDocumentsTier1List' });

  frDocumentsTier2List = () => Actions.setView({ page: 'frDocumentsTier2List' });

  frDocumentsEscalatedList = () => Actions.setView({ page: 'frDocumentsEscalatedList' });

  frDocumentsDetails = (customerId) => Actions.setView({ page: 'frDocumentsDetails', customerId });

  resume = () => Actions.setView({ page: 'resume' });

  findProducts = () => Actions.setView({ page: 'findProducts' });

  notFound = () => Actions.setView({ page: 'not-found' });

  accountDetails = () => Actions.setView({ page: 'accountDetails' });

  decisioningTable = () => Actions.setView({ page: 'decisioningTable' });

  decision = (decisionId) => Actions.setView({ page: 'decision', decisionId });

  userList = () => Actions.setView({ page: 'userList' });

  userListByCompany = (coid) => Actions.setView({ page: 'userList', coid });

  companyInfo = () => Actions.setView({ page: 'companyInfo' });

  companyInfoByCompany = (coid) => Actions.setView({ page: 'companyInfo', coid });

  companyList = () => Actions.setView({ page: 'companyList' });

  companyDetails = () => Actions.setView({ page: 'companyDetails' });

  branchList = (coid) => Actions.setView({ page: 'branchList', coid });

  branchDetails = (coid, branchId) => Actions.setView({ page: 'branchDetails', coid, branchId });

  notificationList = (coid) => Actions.setView({ page: 'notificationList', coid });

  notificationDetails = (coid, subscriptionId) =>
    Actions.setView({ page: 'notificationDetails', coid, subscriptionId });

  licenseList = (coid) => Actions.setView({ page: 'licenseList', coid });

  licenseDetails = (coid, licenseId) => Actions.setView({ page: 'licenseDetails', coid, licenseId });

  editCompany = () => Actions.setView({ page: 'editCompany' });

  editUser = (id) => Actions.setView({ page: 'editUser', id });

  editUserByCoid = (coid, id) => Actions.setView({ page: 'editUser', coid, id });

  pricingGroupList = (coid) => Actions.setView({ page: 'pricingGroupList', coid });

  pricingGroupDetails = (coid, pricingId) => Actions.setView({ page: 'pricingGroupDetails', coid, pricingId });

  authorizedSignerList = (coid) => Actions.setView({ page: 'authorizedSignerList', coid });

  authorizedSignerDetails = (coid, signerId) => Actions.setView({ page: 'authorizedSignerDetails', coid, signerId });

  newUser = (coid) => Actions.setView({ page: 'newUserByCompany', coid });

  infoDisplayPage = (docName) => Actions.setView({ page: 'infoDisplayPage', docName });

  cognitoAuth = () => Actions.setView({ page: 'cognitoAuth' });

  fakeCognitoAuth = () => Actions.setView({ page: 'fakeCognitoAuth' });

  pendingCognitoAuth = () => Actions.setView({ page: 'pendingCognitoAuth' });

  maintenancePage = () => Actions.setView({ page: 'maintenancePage' });

  quickCheckRemoteCompleted = () => Actions.setView({ page: 'quickCheckRemoteCompleted' });

  webhookStatusPage = (customerId) => Actions.setView({ page: 'webhookStatusPage', customerId });

  sponsorEventsStatusPage = (customerId) => Actions.setView({ page: 'sponsorEventsStatusPage', customerId });

  customerRedirectPage = (id) => Actions.setView({ page: 'customerRedirectPage', id });

  impersonationStandByPage = () => Actions.setView({ page: 'impersonationStandByPage' });

  kbaFailure = (data) => Actions.setView({ page: 'kbaFailure', data });

  qaHiddenV2 = (data) => Actions.setView({ page: 'qaHiddenV2', data });

  disbursements = (data) => Actions.setView({ page: 'disbursements', data });

  signInPerson = (data) => Actions.setView({ page: 'signInPerson', data });

  signingComplete = (data) => Actions.setView({ page: 'signingComplete', data });

  mockMosaicEsign = (data) => Actions.setView({ page: 'mockMosaicEsign', data });

  customerHistory = (data) => Actions.setView({ page: 'customerHistory', data });

  welcomeCall = (data) => Actions.setView({ page: 'welcomeCall', data });

  welcomeCallErrorPage = (data) => Actions.setView({ page: 'welcomeCallErrorPage', data });

  securityCenter = (data) => Actions.setView({ page: 'securityCenter', data });

  mfaPage = (data) => Actions.setView({ page: 'mfaPage', data });

  welcomeCallCompletePage = (guid) => Actions.setView({ page: 'welcomeCallCompletePage', guid });

  autoPayCompletePage = (token) => Actions.setView({ page: 'autoPayCompletePage', token });

  autoPayPreferencesPage = (token) => Actions.setView({ page: 'autoPayPreferencesPage', token });

  configRouter = (data) => Actions.setView({ page: 'configRouter', data });

  borrowerInfo = (id) => Actions.setView({ page: 'borrowerInfo', id });

  uxPage = () => Actions.setView({ page: 'uxPage' });

  snapshot = (id) => Actions.setView({ page: 'snapshot', id });

  ensembleView = (id) => Actions.setView({ page: 'ensembleView', id });
}
